import { EditableGrowingInput, OverflowText, TooltipWrapper } from "@theorgchartdev/storybook";
import cx from "classnames";
import React, { Fragment, useRef } from "react";
import { GetWSMgr, ReRenderCanvas } from "@/Utils/StateLib";
import { QAlert } from "@coreapp/CoreApp/QAlert";
import { appstr } from "@coreapp/utils/appstr";

export const RenameLayoutInput = props => {
  const wsMgr = GetWSMgr();
  const bsMgr = wsMgr?.fBoxStylesMgr;
  const layoutRef = wsMgr?.fLayoutPanel;

  const nameInputRef = useRef(null);
  const handleRef = useRef(null);

  const renameActive = handleRef?.current?.editMode;
  const renameClass = "oc-main-name-input";

  const isEditingBoxLayout = () => {
    return layoutRef?.fEditBoxStyle;
  };

  const getCurrentBoxStyle = () => {
    return layoutRef?.fLayout;
  };

  const validateName = newName => {
    const layout = getCurrentBoxStyle();
    return { success: bsMgr.IsUniqueBoxStyleName(newName, layout) };
  };

  const onRenameCommit = newName => {
    let l = getCurrentBoxStyle();
    if (l == null || newName === getCurrentName()) return null;
    layoutRef.fNameChange = newName;
    l.SetBoxStyleName(newName);
    l.fDirty = true;
    wsMgr?.BroadcastTopic?.("boxStyleNameChanged");
    wsMgr?.OnLayoutMutated?.();
    ReRenderCanvas();
  };

  const getCurrentName = () => {
    const layout = getCurrentBoxStyle();
    if (!layout) return appstr("Box style");
    return layout.GetBoxStyleName();
  };

  const handleRenameBoxlayout = newName => {
    const nameValidationCheck = validateName(newName);
    if (!nameValidationCheck.success) {
      var w = new QAlert();
      w.InitAlert(appstr("Box style name in use"), appstr("Choose unique name"), this, wsMgr);
      return;
    }
    onRenameCommit(newName);
  };

  const layout = layoutRef?.fLayout;

  return (
    <Fragment>
      {isEditingBoxLayout() && layout != null ? (
        <TooltipWrapper tooltipProps={{ message: appstr("Rename") }}>
          <div
            className={cx(renameClass, !renameActive && layout?.fDirty && `${renameClass}--italic`)}
          >
            <EditableGrowingInput
              dataTestId={"oc-rename-input"}
              size={"large"}
              ref={nameInputRef}
              handleRef={handleRef}
              text={getCurrentName()}
              onChange={handleRenameBoxlayout}
            />
          </div>
        </TooltipWrapper>
      ) : (
        <OverflowText size={"large"} modifier={"medium"}>
          {"Box style"}
        </OverflowText>
      )}
    </Fragment>
  );
};
